// Libraries
import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background.default};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    padding: 40px 48px 40px 24px;
  }
`
